import { render, staticRenderFns } from "./HeaderAvatarMenu.vue?vue&type=template&id=e3a8aeb2&scoped=true&"
import script from "./HeaderAvatarMenu.vue?vue&type=script&lang=js&"
export * from "./HeaderAvatarMenu.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAvatarMenu.vue?vue&type=style&index=0&id=e3a8aeb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a8aeb2",
  null
  
)

export default component.exports